import * as React from "react";
import Grid from "@mui/material/Grid";
import moment from "moment";
import { Typography } from "@mui/material";
import { CmpStatusIconV1 } from "../../../Component/Common/ToolBox/ToolBox";
export const VarianceTblCard = ({ data = [], onClick = () => {} }) => {
  return (
    <Grid container spacing={0.5} className="mt-1">
      {data?.map((item, index) => (
        <Grid
          item
          xs={12}
          sm={12}
          md={4}
          lg={4}
          key={index}
          onClick={() => {
            let items = { row: item };
            onClick(items);
          }}
        >
          <div  className="easy-putaway-card-v1">
          <Grid
            container
            spacing={0}
            rowSpacing={1}
            // sx={{
            //   borderWidth: "1px 1px 1px 5px",
            //   borderStyle: "solid solid solid solid",
            //   borderRadius: "10px 10px 10px 10px",
            //   padding: "12px 8px",
            //   marginTop: "5px",
            //   borderColor: "#0d73bb",
            //   border: " 1px solid lightgray",
            //   boxShadow:
            //     "1px 3px 7px 1px rgb(130 132 139 / 53%), 0 2px 10px 0 rgb(24 78 227 / 28%)",
            // }}
            columns={{ xs: 12, sm: 12, md: 12 }}
           
          >
            

            <Grid item xs={12} sm={12} md={12} className="easy-putaway-card-sub-Item">
              <Typography
                className="easy-putaway-card-sub-ItemName" 
                component={"span"}
              >
                {item?.ItmName}
              </Typography>
            </Grid>

            
 
            
            <Grid item xs={2} sm={2}  md={3} >
              <Typography
                className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                 Trans
              </Typography>
            </Grid>

            <Grid item xs={2} sm={4}  md={3} >
              <Typography
                className=" CardFontStyleValue CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                {item?.B_Qty}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={2}  md={3}  >
              <Typography
                className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                Batch
              </Typography>
            </Grid>

            <Grid item xs={2} sm={4}  md={3}  >
              <Typography
                className=" CardFontStyleValue CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                {item?.DP_Qty}
              </Typography>
            </Grid>
            <Grid item xs={2} sm={2}  md={3}  >
              <Typography
                className="CardFontStyleLabel CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                Diff 
              </Typography>
            </Grid>

            <Grid item xs={2} sm={4}  md={3}  >
              <Typography
                className=" CardFontStyleValue CardFontStyle txt-overflow-ellipse"
                component={"span"}
              >
                {item?.QtyDiff}
              </Typography>
            </Grid>
              
          </Grid>
          </div>
         
        </Grid>
      ))}
    </Grid>
  );
};
